import { BellOutlined } from '@ant-design/icons';
import { Badge, Button } from 'antd';
import React from 'react';
import { useUnreadCount } from '../../../utils/api/notifications/useUnreadCount';

const NotificationsBell = ({ onClick }) => {
  const { unread } = useUnreadCount();

  return (
    <Badge count={unread} size="small">
      <Button
        type="text"
        icon={<BellOutlined style={{ fontSize: 20, color: '#f8fff0' }} />}
        onClick={onClick}
      />
    </Badge>
  );
};

export default NotificationsBell;
